import { ActionContext } from 'vuex';
import { getUserInfo } from '@/api/user';
import { UserDataResponse, UserState } from '@/interfaces/user';
import fullStory from '@/logging';
import applicationId from '@/filters/application-id';

type Context = ActionContext<UserState, never>;

export async function fetchUserInfo(context: Context): Promise<UserDataResponse> {
  const { data } = await getUserInfo();

  context.commit('setUserState', data);

  fullStory.identify(data.user_id.toString(), {
    email: data.email,
    name: `${data.first_name} ${data.last_name}`
  });

  if (context.getters.activeLoanNumber) {
    const loan = context.getters.activeLoan;

    fullStory.addUserData({
      loan_number: applicationId(loan.loan_number),
      merchant_id: loan.merchant_human_readable_id,
      merchant_uuid: loan.merchant_uuid,
    });
  }

  return data;
}

export function setActiveLoan(context: Context, loanNumber: string) {
  context.commit('setActiveLoan', loanNumber);

  const loan = context.getters.activeLoan;

  fullStory.addUserData({
    loan_number: applicationId(loan.loan_number),
    merchant_id: loan.merchant_human_readable_id,
    merchant_uuid: loan.merchant_uuid,
  });
}

export function setIsFirstLogin(context: Context, isFirstLogin: boolean) {
  context.commit('setIsFirstLogin', isFirstLogin);
}
